import './nuevoStroLight.css';
import { useCookies } from 'react-cookie';
import { useActualizarSiniestro } from '../../../context/ActualizarSiniestro';

export default function EstadoReclamoBloqueLight({ reclamo }) {
  const [cookies] = useCookies(['user']);
  const { actualizarReclamo, reclamosEditados } = useActualizarSiniestro();
  const reclamoActualizado = reclamosEditados?.find(r => r.id === reclamo?.id);
  const estado = reclamoActualizado?.estado;
  const valoresEstado = reclamoActualizado?.valores?.[Number(estado)] || {};
  const primerValor = valoresEstado[Object.keys(valoresEstado)[0]];

  if (!reclamo || Number(estado) === 200) return null;

  return (
    <section className='estadoBloqueColDer'>
      <div className='d-flex justify-content-between align-items-center mb-3'>
        <div className='d-flex gap-5'>
          <h2 className='tituloModuloEstados'>{reclamoActualizado?.estados?.find(e => e.id === Number(estado))?.nombre}</h2>
        </div>
        <h2 className='modificacionModuloEstados'>
          <i className='bi bi-calendar-week me-1'></i>
          Ult Mod: {primerValor}
        </h2>
      </div>
      <form>
        <div className='containerEstados'>
          {reclamoActualizado?.camposEstado?.[Number(estado)]
            ?.filter(c => c.oculto === 0)
            .slice(1)
            .filter(campo => {
              if (!campo.depende) return true;
              const valorDependencia = reclamoActualizado?.valores?.[Number(estado)]?.[campo.depende];
              return !!valorDependencia;
            })
            .map((campo, index) => {
              const valorCampo = reclamoActualizado?.valores?.[Number(estado)]?.[campo.nombre];
              return (
                <div key={index}>
                  <label className='reclamoSpan'>{campo.label.toUpperCase()}</label>
                  {campo.type === 'select' ? (
                    <select
                      className='burbujaReclamoNuevo'
                      value={valorCampo}
                      onChange={e => actualizarReclamo(reclamoActualizado.id, ['valores', Number(estado), campo.nombre], e.target.value)}
                      disabled={cookies?.user?.titulo === 'lector'}>
                      {(valorCampo === null || valorCampo === '') && (
                        <option value='' disabled>
                          Selecciona una opción
                        </option>
                      )}
                      {campo.opciones.split(',').map((opcion, i) => (
                        <option key={i} value={opcion.trim()}>
                          {opcion.trim()}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type={campo.type}
                      disabled={cookies?.user?.titulo === 'lector'}
                      className={campo.type === 'checkbox' ? 'form-check-input rounded-pill' : 'burbujaReclamoNuevo'}
                      style={campo.type === 'date' ? { maxWidth: '180px' } : campo.type === 'number' ? { maxWidth: '180px' } : { maxWidth: '180px' }}
                      value={campo.type !== 'checkbox' ? valorCampo : undefined}
                      checked={campo.type === 'checkbox' ? valorCampo : undefined}
                      onChange={e => actualizarReclamo(reclamoActualizado.id, ['valores', Number(estado), campo.nombre], campo.type === 'checkbox' ? e.target.checked : e.target.value)}
                    />
                  )}
                </div>
              );
            })}
        </div>
      </form>
    </section>
  );
}
